import { PublicReview } from '@shared/types';
import { PublicEducator } from '@cademy-package/sdk-component-types';
import Image from 'next/image';
import { FunctionComponent, useMemo, useState } from 'react';
import getVagueTimeAgo from '../../../services/getVagueTimeAgo';
import styles from './styles.module.scss';
import { Temporal } from 'temporal-polyfill';
import { LocalDate } from '../../LocalDate';

const FALLBACK_IMAGE = `${process.env.NEXT_PUBLIC_ASSETS_URL}/images/educator_fallback_logo.svg`;

const EducatorResponse: FunctionComponent<{
    response: PublicReview['educatorResponse'];
    educator: PublicEducator;
}> = ({ response, educator }) => {
    const [imgSrc, setImgSrc] = useState(encodeURI(educator.logo_url || FALLBACK_IMAGE));

    const timeAgo = useMemo(() => {
        if (!response) {
            return null;
        }

        const now = new Date();
        const reviewDate = new Date(response.createdAt * 1000);
        const diff = Math.round((now.getTime() - reviewDate.getTime()) / 1000);
        return getVagueTimeAgo(diff);
    }, [response]);

    if (!response) {
        return null;
    }

    const message = response.message ? <p>{response.message}</p> : null;

    return (
        <div className={styles.educatorResponse}>
            <div className={styles.header}>
                <Image
                    src={imgSrc}
                    alt={educator.name}
                    height={40}
                    width={40}
                    onError={() => setImgSrc(FALLBACK_IMAGE)}
                />
                <div className={styles.educatorName}>{educator.name}</div>
                <div className={styles.date}>
                    Responded&nbsp;
                    <LocalDate
                        date={Temporal.Instant.fromEpochSeconds(response.createdAt)}
                        format="relative"
                        titleFormat="default"
                    />
                </div>
            </div>
            {message}
        </div>
    );
};

export default EducatorResponse;
